{
  "version": "0.13.0",
  "gzip": {
    "path": "iwads/freedoom1.wad.gz",
    "bytes": 10304935,
    "sha256": "49837dd8f11d558bc26a48a50a653fcd3168e7f18c1c385057053c53282599ff"
  },
  "wad": {
    "bytes": 28795076,
    "sha256": "7323bcc168c5a45ff10749b339960e98314740a734c30d4b9f3337001f9e703d"
  },
  "notices": [
    {
      "name": "COPYING.txt",
      "bytes": 1644,
      "sha256": "7c62f2c520769c798774f416637eec4921e5f0aafdac1245ae7c8a8cf65fe102"
    },
    {
      "name": "CREDITS.txt",
      "bytes": 15872,
      "sha256": "72364333d295c598d75ef9553d3b3661ad0b60e27271c87b7637c74b2f46918a"
    },
    {
      "name": "CREDITS-MUSIC.txt",
      "bytes": 9388,
      "sha256": "2bb77677bbc4e587bba44ccb6514ee0f5397c7bb8ae9580b9188d3d6a57c0a31"
    }
  ]
}
